// extracted by mini-css-extract-plugin
module.exports = {"center":"donation-module--center--23tEl","container":"donation-module--container--3lXbV","cardStyles":"donation-module--cardStyles--2RitR"};